import { render, staticRenderFns } from "./HardwareResourceGauge.vue?vue&type=template&id=613bfb4e&scoped=true&"
import script from "./HardwareResourceGauge.vue?vue&type=script&lang=js&"
export * from "./HardwareResourceGauge.vue?vue&type=script&lang=js&"
import style0 from "./HardwareResourceGauge.vue?vue&type=style&index=0&id=613bfb4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bfb4e",
  null
  
)

export default component.exports